import React from "react";

const Mycontext = React.createContext();

export default Mycontext;
